/*
 * Filename: d:\projects\AutoFiFront\src\Content\CarInfo\CarInfo.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Friday, January 13th 2023, 2:10:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { TbGasStation,  } from "react-icons/tb";
import { FaExternalLinkAlt } from "react-icons/fa";
import { GiGearStickPattern } from "react-icons/gi";
import { TfiLocationPin } from "react-icons/tfi";
import { MdOutlineColorLens } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { TbSteeringWheel } from "react-icons/tb";
import { BiTachometer } from "react-icons/bi";
import { MdOutlineEuroSymbol } from "react-icons/md";
import { AiTwotoneInfoCircle } from "react-icons/ai";
import styles from "Content/Car/CarInfo/CarInfo.module.css";
import CarInfoIcon from "Theme/Component/CarInfoIcon";
import translator from "MultiLanguage/TranslationWrapper";
import 'moment/locale/fr';
import { BsCalendar2Week } from "react-icons/bs";
import { useAuth } from "Router/AuthProvider";
import { IoCarSportOutline } from "react-icons/io5";
import { ReactElement } from "react";

export type CarInfoTypeProps = {
    Brand: string,
    Model: string,
    Version: string,
    Energy: string,
    RegNb: string,
    Gears: string,
    CirculationDate: Date,
    Mileage: number,
    Park: string,
    Color: string,
    Link: string,
    Nb_Col: number,
    Nb_Elem: number,
    Car_Type: string,
    themeColor?: string,
    RepairCost: number,
    hasEllipsis?: boolean
};

function CarInfo (props: CarInfoTypeProps) {
    const { isConnected } = useAuth();
    const Car_Brand = `${props.Brand.toUpperCase()} ${props.Model.toUpperCase()}`;
    const Car_Underline= props.Version.toUpperCase();
    const Car_Energy = translator.decode(`energyType.${props.Energy.toLowerCase()}`).toUpperCase();
    const Car_Gears = props.Gears;
    const Car_Park = props.Park.toUpperCase();
    const Car_Color = props.Color.toUpperCase();
    const Car_Type = props.Car_Type.toUpperCase();
    const Car_RegNb = props.RegNb?.toUpperCase();
    const Car_RepairCost = props.RepairCost ? `${translator.decode("car.repairCost")}: ${props.RepairCost}€ TTC` : null;
    const Link = props.Link;
    const Nb_Elem = props.Nb_Elem;
    const Nb_col = props.Nb_Col;
    const ClassNameCol = 12 / Nb_col;
    const Nb_Row = Math.trunc(Nb_Elem / Nb_col) + Nb_Elem % Nb_col;

    const itemToDisplay: { name: any, icon: ReactElement<any, any>, tooltip?: string }[] = [
        {
            name: translator.decode(`car.${Car_Gears.toLowerCase()}`).toUpperCase(),
            icon: <GiGearStickPattern/>
        },
        {
            name: Car_Energy,
            icon: <TbGasStation />
        },
        {
            name: new Date (props.CirculationDate).toLocaleDateString(),
            icon: <BsCalendar2Week/>
        },
        {
            name: `${props.Mileage.toString().slice(0, props.Mileage.toString().length -3 > 0 ? props.Mileage.toString().length -3 : 0)} ${props.Mileage.toString().slice(-3)}${translator.decode("orderby.mileage")}`,
            icon: <BiTachometer/>
        },
        {
            name: Car_Color,
            icon: <MdOutlineColorLens/>
        },
        {
            name: Car_Park,
            icon: <TfiLocationPin/>
        },
        {
            name: Car_Type,
            icon: <TbSteeringWheel/>
        },
    ];

    if (Car_RepairCost)
        itemToDisplay.push({ name: Car_RepairCost, icon: <MdOutlineEuroSymbol />, tooltip: "dynamic.repair_engagement" });
    if (isConnected) {
        itemToDisplay.push({ name: Car_RegNb, icon: <IoCarSportOutline />, tooltip: undefined });
        itemToDisplay.push({ name: Link, icon: <FaExternalLinkAlt />, tooltip: undefined });
    }
    const myRows: any[] = [];
    let k = 0;
    for (let i = 0; i < Nb_Row; ++i) {
        const myItems: any[] = [];
        for (let j = 0; j < Nb_col; ++j) {
            if (k < itemToDisplay.length && itemToDisplay[k].name != "" && itemToDisplay[k].name != null) {
                if (itemToDisplay[k].name == Link) {
                    myItems.push(<div key={Math.random()} className={`${styles.car_info_sub_data} col-${ClassNameCol}`}>
                        <CarInfoIcon bgColor={props.themeColor}>{itemToDisplay[k].icon}</CarInfoIcon>
                        <a href={Link} className={`${styles.linkAuto}`} target="_blank">{translator.decode("dynamic.report").toUpperCase()}</a>
                    </div>);
                } else {
                    myItems.push(<div key={Math.random()} className={`${styles.car_info_sub_data} col-${ClassNameCol}`}>
                        <CarInfoIcon bgColor={props.themeColor}>{itemToDisplay[k].icon}</CarInfoIcon>
                        {itemToDisplay[k].name}{itemToDisplay[k].tooltip ? <Tooltip className={`${styles.options}`} title={translator.decode(itemToDisplay[k].tooltip!)}><span className={`${styles.iconLike }`}><AiTwotoneInfoCircle /></span></Tooltip> : null}
                    </div>);
                }
            }
            ++k;
        }
        myRows.push(<div key={Math.random()} className={`${styles.car_info_row} row`} >{myItems}</div>);
    }

    return (
        <div className={`${styles.car_info}`}>
            <div className={`${styles.car_info_name}`}>
                <h2 className={`${Car_Brand.length > 20 ? styles.titleShort : ""}`}> {Car_Brand} </h2>
                <h3 className={`${props.hasEllipsis ? styles.titleEllipsis : ""}`}> {Car_Underline} </h3>
            </div>
            {myRows}
        </div>
    );
}

export default CarInfo;
